import { reactive, ref, computed } from 'vue';

// Supported locales: 'es-EC' (Ecuador - Spanish) and 'en-US' (United States - English)
export const currentLocale = ref(localStorage.getItem('apple_locale') || 'es-EC');

export const translations = {
  'es-EC': {
    nav: {
      store: 'Tienda',
      mac: 'Mac',
      ipad: 'iPad',
      iphone: 'iPhone',
      watch: 'Watch',
      vision: 'Vision',
      airpods: 'AirPods',
      tvHome: 'TV y Hogar',
      entertainment: 'Entretenimiento',
      support: 'Soporte',
      preOrder: 'Reservar',
      overview: 'Información general',
      intelligence: 'Apple Intelligence',
      personalize: 'Personalizar',
      photos: 'Fotos',
      messages: 'Mensajes',
      compatibility: 'Compatibilidad',
      countryName: 'Ecuador'
    },
    hero: {
      badge: 'Lanzamiento de iOS 18 y iPhone 18',
      title: 'iPhone 18 Pro',
      tagline: 'El Pro va por más.',
      availability: 'Consulta la disponibilidad más adelante.',
      learnMore: 'Más información',
      preOrderBtn: 'Más información',
      exploreBtn: 'Explorar Apple Intelligence',
      spec1Label: 'Inteligencia',
      spec1Title: 'Apple Intelligence',
      spec1Desc: 'IA personal, privada y potente en el dispositivo.',
      spec2Label: 'Personalización',
      spec2Title: 'Iconos y Diseño con Tinte',
      spec2Desc: 'Organiza apps donde quieras con tonos de color personalizados.',
      spec3Label: 'Vida Diaria',
      spec3Title: 'Fotos Rediseñadas',
      spec3Desc: 'Fototeca unificada con Colecciones inteligentes organizadas.'
    },
    iphoneFold: {
      badge: 'Nuevo',
      title: 'iPhone Duo',
      tagline: 'Hola, hola.',
      availability: 'Consulta la disponibilidad más adelante.',
      learnMore: 'Más información',
      buy: 'Comprar'
    },
    store: {
      heroEyebrow: 'Tienda Apple Oficial',
      heroTitle: 'La mejor forma de comprar los productos que te encantan.',
      heroSubtitle: 'Descubre los últimos lanzamientos de iPhone, Mac, iPad, Apple Watch y más con beneficios exclusivos del 50.° Aniversario.',
      categories: 'Categorías de Productos',
      all: 'Todos los Productos',
      filterIphone: 'iPhone',
      filterMac: 'Mac',
      filterIpad: 'iPad',
      filterWatch: 'Apple Watch',
      filterAirpods: 'AirPods',
      filterVision: 'Vision Pro',
      filterGiftCard: 'Tarjetas de Regalo',
      buyNow: 'Comprar',
      redeemNow: 'Canjear / Redimir',
      learnMore: 'Más información',
      from: 'Desde',
      freeShipping: 'Envío gratuito en todos los pedidos',
      tradeInBanner: 'Aceptamos tu dispositivo en canje',
      installments: 'Financiamiento al 0% de interés',
      support: 'Especialistas Apple listos para ayudarte'
    },
    promoGrid: {
      airpodsTitle: 'AirPods 5',
      airpodsTagline: 'Descubre la magia<br/>de la Cancelación Activa de Ruido.',
      airpodsAvailability: 'Consulta la disponibilidad más adelante.',
      airpodsBtn: 'Más información',
      macbookTitle: 'MacBook Air',
      macbookTagline: 'Ahora con los superpoderes del chip M5.',
      macbookLearn: 'Más información',
      macbookBuy: 'Comprar'
    },
    tvSlider: {
      streamNow: 'Ver ahora',
      siloGenre: 'Ciencia ficción',
      siloDesc: 'La verdad se esconde en el pasado.',
      severanceGenre: 'Thriller',
      severanceDesc: 'Descubre qué sucede cuando dejas el trabajo atrás.',
      morningGenre: 'Drama',
      morningDesc: 'El caos nunca duerme.',
      tedGenre: 'Comedia',
      tedDesc: 'La amabilidad siempre gana.'
    },
    intelligence: {
      badge: 'Apple Intelligence',
      title: 'Apple Intelligence',
      tagline: 'IA para todos nosotros.',
      description: 'Integrada profundamente en tu iPhone, iPad y Mac, Apple Intelligence te ayuda a escribir, expresarte y hacer las cosas con total facilidad, todo con una arquitectura de privacidad revolucionaria.',
      siriActive: 'Siri escuchando… (Haz clic para cerrar)',
      siriInactive: 'Toca para invocar a Siri y ver el resplandor',
      tabWriting: 'Herramientas de Redacción',
      tabPlayground: 'Image Playground',
      tabGenmoji: 'Genmoji',
      tabSiri: 'Nueva Era de Siri',
      writingEyebrow: 'Herramientas de Escritura',
      writingTitle: 'Exprésate con precisión impecable.',
      writingDesc: 'Reescribe, revisa y resume textos prácticamente donde escribas: Mail, Notas, Pages y apps de terceros. Ajusta tu tono de Amigable a Profesional con un solo toque.',
      playgroundEyebrow: 'Image Playground',
      playgroundTitle: 'Crea imágenes originales en segundos.',
      playgroundDesc: 'Elige entre estilos como Animación, Ilustración o Boceto y genera conceptos visuales únicos directamente en Mensajes o Freeform.',
      genmojiEyebrow: 'Genmoji',
      genmojiTitle: 'Un emoji hecho exactamente para el momento.',
      genmojiDesc: 'Crea un Genmoji completamente nuevo directamente en el teclado escribiendo una simple descripción.',
      siriEyebrow: 'Siri Inteligente',
      siriTitle: 'Más rica en contexto e intuitiva.',
      siriDesc: 'Con una comprensión lingüística mejorada y el nuevo resplandor en pantalla, interactuar con Siri se siente fluido y natural.'
    },
    customization: {
      badge: 'Personalizar',
      title: 'Personalización Profunda',
      tagline: 'Tu iPhone. Más tuyo que nunca.',
      description: 'Organiza tus apps y widgets libremente. Dale un tinte a los íconos de las apps que combine con tu fondo. Y accede a tus controles favoritos más rápido con el nuevo Centro de Control.',
      exploreAppearance: 'Explora la apariencia de los iconos de apps:',
      styleDark: 'Modo Oscuro',
      styleDarkDesc: 'Los iconos se adaptan automáticamente a una estética oscura refinada.',
      styleTinted: 'Tintado Personalizado',
      styleTintedDesc: 'Aplica cualquier tono de color a todos los iconos de apps.',
      styleLight: 'Modo Claro',
      styleLightDesc: 'Aspecto icónico y nítido de iOS con colores vibrantes.',
      ccEyebrow: 'Rediseño del Centro de Control',
      ccTitle: 'Grupos de control continuos y deslizables.',
      ccDesc: 'El diseño renovado del Centro de Control brinda un acceso ultrarrápido a tus controles más utilizados: reproducción, controles de Casa y conectividad, con tamaños personalizables.',
      tabFavorites: 'Controles Favoritos',
      tabMedia: 'Reproducción y Audio',
      tabHome: 'Accesorios del Hogar',
      tabConnectivity: 'Redes y Satélite'
    },
    photos: {
      badge: 'Fotos',
      title: 'Fotos Rediseñadas',
      tagline: 'Un rediseño histórico. El más grande hasta ahora.',
      description: 'Una vista unificada y simplificada reemplaza las pestañas separadas, organizando tu fototeca por temas útiles como Días Recientes, Viajes y Personas y Mascotas, para que disfrutes más tus recuerdos.',
      tab1Name: 'Fototeca Unificada',
      tab1Heading: 'Todo en una sola vista hermosa.',
      tab1Desc: 'Navega por toda tu fototeca con una cuadrícula simplificada en la parte superior y colecciones temáticas inteligentes debajo.',
      tab1Bullet1: 'Cuadrícula superior con vistas flexibles por año o mes',
      tab1Bullet2: 'Filtrado instantáneo para ocultar capturas y recibos',
      tab1Bullet3: 'Acceso rápido con un deslizamiento hacia arriba',
      tab2Name: 'Colecciones',
      tab2Heading: 'Organizado inteligentemente por momentos.',
      tab2Desc: 'Explora tus fotos agrupadas automáticamente por viajes recientes, eventos familiares y tus recuerdos favoritos.',
      tab2Bullet1: 'Temas inteligentes de Días Recientes y Viajes',
      tab2Bullet2: 'Grupos de Personas y Mascotas destacados',
      tab2Bullet3: 'Colecciones personalizables y reordenables',
      tab3Name: 'Edición Mágica',
      tab3Heading: 'Herramientas de retoque profesional.',
      tab3Desc: 'Limpia distracciones de tus fotos con la nueva herramienta Clean Up impulsada por Apple Intelligence sin alterar el sujeto principal.',
      tab3Bullet1: 'Herramienta Limpiar para eliminar objetos no deseados',
      tab3Bullet2: 'Ajustes de memoria y generación de historias en video',
      tab3Bullet3: 'Búsqueda en lenguaje natural para encontrar cualquier toma'
    },
    messages: {
      badge: 'Mensajes',
      title: 'Mensajes Conectados',
      tagline: 'Nuevas formas de mantenerte conectado.',
      description: 'Exprésate como nunca antes con animaciones de texto dinámicas, reacciona con cualquier emoji o sticker con Tapback, programa mensajes y envía textos vía satélite cuando estés sin cobertura.',
      simEyebrow: 'Función Interactiva',
      simTitle: 'Nuevos Efectos de Texto Animados',
      simDesc: 'Haz clic en un efecto abajo para ver el formato dinámico dar vida a tus palabras en tiempo real:',
      sampleText: '¡Nos vemos en Quito esta noche!',
      sampleBig: '¡ESTO ES INCREÍBLE!',
      sampleBounce: '¡Saltemos de alegría! 🎉',
      sampleGlow: '✨ Una noche mágica ✨',
      sampleShake: '¡Atención a todos!',
      tapbackLabel: 'Reacciona con Tapback y emojis:'
    },
    features: {
      badge: 'Aún Más Innovaciones',
      title: 'Innovaciones Integradas',
      tagline: 'Potencia en cada detalle.',
      description: 'Repleto de avances inteligentes en las apps que utilizas todos los días.',
      safariTag: 'Safari',
      safariTitle: 'Destacados y Control de Distracciones',
      safariDesc: 'Safari utiliza aprendizaje automático en el dispositivo para detectar y mostrar automáticamente información clave: direcciones, resúmenes o enlaces rápidos. Oculta elementos molestos fácilmente.',
      passwordsTag: 'Seguridad',
      passwordsTitle: 'La Nueva App Contraseñas',
      passwordsDesc: 'Basada en 25 años de Llavero de iCloud, centraliza todas tus credenciales, llaves de acceso, contraseñas de Wi-Fi y códigos de autenticación con cifrado de extremo a extremo.',
      mathTag: 'Notas y Calculadora',
      mathTitle: 'Math Notes',
      mathDesc: 'Escribe o dibuja ecuaciones matemáticas a mano y observa cómo se resuelven al instante con gráficos interactivos y soluciones integradas.',
      mapsTag: 'Mapas',
      mapsTitle: 'Rutas Topográficas de Senderismo',
      mapsDesc: 'Descarga mapas sin conexión y explora miles de senderos con elevación detallada y guías paso a paso.',
      gamingTag: 'Rendimiento',
      gamingTitle: 'Modo Juego Mejorado',
      gamingDesc: 'Maximiza las tasas de cuadros por segundo continuas y reduce drásticamente la latencia de AirPods y controles inalámbricos.'
    },
    compatibility: {
      badge: 'Compatibilidad',
      title: 'Compatibilidad de Dispositivos',
      tagline: 'iOS 18 en tu iPhone.',
      description: 'Apple Intelligence está disponible en modelos iPhone 16, iPhone 15 Pro y iPhone 15 Pro Max con Siri e idioma compatible.',
      searchPlaceholder: 'Busca tu modelo de iPhone (ej. iPhone 18, iPhone 16 Pro, iPhone 13)...',
      filterAll: 'Todos los iPhones Compatibles',
      filterAi: '✦ Compatibles con Apple Intelligence',
      chipLabel: 'Chip:',
      flagshipTag: 'Insignia',
      supportedBadge: 'Compatible con iOS 18',
      aiSupported: 'Apple Intelligence Compatible',
      standardFeatures: 'Funciones Estándar de iOS 18',
      noResults: 'No se encontró ningún iPhone coincidente con "{query}".',
      upgradeEyebrow: '¿Listo para actualizar?',
      upgradeTitle: 'Cómo actualizar tu iPhone a iOS 18',
      step1: 'Abre la app <strong>Configuración</strong> en tu iPhone.',
      step2: 'Toca <strong>General</strong> y luego <strong>Actualización de software</strong>.',
      step3: 'Toca <strong>Actualizar a iOS 18</strong> y sigue las instrucciones en pantalla.',
      preOrderAction: 'Reservar iPhone 18 y Asegurar Acceso'
    },
    form: {
      countryLabel: 'País / Región',
      countryEcuador: 'Ecuador',
      countryUsa: 'Estados Unidos',
      selectProvince: 'Selecciona una provincia',
      selectState: 'Selecciona un estado',
      step1Title: 'Iniciar sesión con Cuenta de Apple',
      step1Label: 'Correo electrónico o número de teléfono',
      rememberMe: 'Recordarme',
      forgotPassword: '¿Olvidaste la contraseña?',
      dontHaveAccount: '¿No tienes una cuenta de Apple?',
      createAccount: 'Crea tu Cuenta de Apple',
      step2Title: 'Información de Facturación',
      firstName: 'Nombre',
      lastName: 'Apellido',
      nameError: 'Nombre y apellido son obligatorios.',
      step3Title: 'Dirección de Facturación',
      streetAddress: 'Dirección de calle / Avenida',
      streetAddress2: 'Departamento, suite, edificio (Opcional)',
      city: 'Ciudad / Cantón',
      province: 'Provincia',
      state: 'Estado',
      postalCode: 'Código Postal',
      phone: 'Teléfono',
      addressError: 'Por favor completa todos los campos requeridos.',
      step4Title: 'Vincular Número de Tarjeta',
      cardNumber: 'Número de Tarjeta',
      cardError: 'Por favor ingresa un número de tarjeta válido',
      step5Title: 'Vencimiento MM/AA y CVV',
      expiry: 'MM / AA',
      cvv: 'CVV',
      expiryError: 'Fecha de vencimiento inválida',
      cvvError: 'CVV es obligatorio',
      step6Title: '¡Listo!',
      step6Subtitle: 'Tu reservación de iPhone 18 y acceso prioritario a iOS 18 han sido confirmados.',
      returnHome: 'Volver a iPhone 18 y iOS 18',
      btnBack: 'Atrás',
      btnNext: 'Siguiente',
      btnSubmit: 'Confirmar y Enviar',
      submitting: 'Enviando...',
      requiresIos: 'Requiere un dispositivo con iOS 17 o posterior.',
      nameRequired: 'El nombre o correo es obligatorio'
    },
    footer: {
      footnote1: 'Según los datos de un estudio realizado por Apple en julio y agosto de 2026 sobre la precisión de la frecuencia cardiaca, usando los dispositivos wearable más vendidos disponibles en el mercado en junio de 2026. Para obtener más información, visita apple.com/HRAccuracy.',
      footnote2: 'Pruebas realizadas por Apple en julio de 2025 usando unidades AirPods Pro 3 enlazadas con unidades iPhone 16 con versiones preliminares de firmware de los AirPods y iOS 26. La prueba de reducción de ruido se realizó según la norma IEC 60268-24. La comparación se realizó con los audífonos internos inalámbricos más vendidos disponibles en el mercado al momento de la prueba. El rendimiento depende de la configuración del dispositivo, el entorno y muchos otros factores.',
      footnote3: 'Apple TV requiere suscripción. Sujeto a restricciones y otros <a href="https://www.apple.com/la/promo/" target="_blank" rel="noopener">términos</a>.',
      footnote4: 'Las funcionalidades están sujetas a cambios. Algunas funcionalidades, aplicaciones y servicios podrían no estar disponibles en todas las regiones o idiomas.',
      shopLearn: 'Comprar y Aprender',
      wallet: 'Apple Wallet',
      appleCard: 'Apple Card',
      applePay: 'Apple Pay',
      appleCash: 'Apple Cash',
      account: 'Cuenta',
      manageAccount: 'Gestionar tu Cuenta de Apple',
      storeAccount: 'Cuenta de Apple Store',
      entertainment: 'Entretenimiento',
      store: 'Apple Store',
      findStore: 'Encontrar una tienda',
      geniusBar: 'Genius Bar',
      todayAtApple: 'Today at Apple',
      tradeIn: 'Apple Trade In',
      orderStatus: 'Estado del pedido',
      aboutApple: 'Acerca de Apple',
      newsroom: 'Newsroom',
      leadership: 'Directivos de Apple',
      careers: 'Oportunidades de empleo',
      investors: 'Inversionistas',
      ethics: 'Ética y cumplimiento',
      events: 'Eventos',
      contact: 'Contactar a Apple',
      copyright: 'Copyright © 2026 Apple Inc. Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Uso',
      salesRefunds: 'Ventas y Reembolsos',
      legal: 'Avisos Legales',
      siteMap: 'Mapa del Sitio'
    }
  },
  'en-US': {
    nav: {
      store: 'Store',
      mac: 'Mac',
      ipad: 'iPad',
      iphone: 'iPhone',
      watch: 'Watch',
      vision: 'Vision',
      airpods: 'AirPods',
      tvHome: 'TV & Home',
      entertainment: 'Entertainment',
      support: 'Support',
      preOrder: 'Pre-order',
      overview: 'Overview',
      intelligence: 'Apple Intelligence',
      personalize: 'Personalize',
      photos: 'Photos',
      messages: 'Messages',
      compatibility: 'Compatibility',
      countryName: 'United States'
    },
    hero: {
      badge: 'iOS 18 & iPhone 18 Release',
      title: 'iPhone 18 Pro',
      tagline: 'Hello, Apple Intelligence.',
      availability: 'Check back for availability.',
      learnMore: 'Learn more',
      preOrderBtn: 'Learn more',
      exploreBtn: 'Explore Apple Intelligence',
      spec1Label: 'Intelligence',
      spec1Title: 'Apple Intelligence',
      spec1Desc: 'Personal, private, powerful on-device AI.',
      spec2Label: 'Customization',
      spec2Title: 'Tinted Icons & Layout',
      spec2Desc: 'Place apps anywhere with custom color tones.',
      spec3Label: 'Everyday Life',
      spec3Title: 'Redesigned Photos',
      spec3Desc: 'Unified library with intelligent Collections.'
    },
    iphoneFold: {
      badge: 'New',
      title: 'iPhone Duo',
      tagline: 'Hello, hello.',
      availability: 'Check back for availability.',
      learnMore: 'Learn more',
      buy: 'Buy'
    },
    store: {
      heroEyebrow: 'Apple Authorized Reseller Store',
      heroTitle: 'The best way to buy the products you love.',
      heroSubtitle: 'Explore the latest iPhone, Mac, iPad, Apple Watch releases and more with exclusive 50th Anniversary benefits.',
      categories: 'Product Categories',
      all: 'All Products',
      filterIphone: 'iPhone',
      filterMac: 'Mac',
      filterIpad: 'iPad',
      filterWatch: 'Apple Watch',
      filterAirpods: 'AirPods',
      filterVision: 'Vision Pro',
      filterGiftCard: 'Gift Cards',
      buyNow: 'Buy',
      redeemNow: 'Redeem / Claim',
      learnMore: 'Learn more',
      from: 'From',
      freeShipping: 'Free delivery on all orders',
      tradeInBanner: 'Trade in your eligible device',
      installments: '0% APR monthly installments available',
      support: 'Apple Specialists ready to help online'
    },
    promoGrid: {
      airpodsTitle: 'AirPods 5',
      airpodsTagline: 'Experience the magic<br/>of Active Noise Cancellation.',
      airpodsAvailability: 'Check back for availability.',
      airpodsBtn: 'Learn more',
      macbookTitle: 'MacBook Air',
      macbookTagline: 'Lean. Mean. M5 machine.',
      macbookLearn: 'Learn more',
      macbookBuy: 'Buy'
    },
    tvSlider: {
      streamNow: 'Stream now',
      siloGenre: 'Sci-Fi',
      siloDesc: 'The truth will surface.',
      severanceGenre: 'Thriller',
      severanceDesc: 'The only way out is through.',
      morningGenre: 'Drama',
      morningDesc: 'Chaos never sleeps.',
      tedGenre: 'Comedy',
      tedDesc: 'Kindness is making a comeback.'
    },
    intelligence: {
      badge: 'Apple Intelligence',
      title: 'Apple Intelligence',
      tagline: 'AI for the rest of us.',
      description: 'Integrated deeply into your iPhone, iPad, and Mac, Apple Intelligence helps you write, express yourself, and get things done effortlessly — all with revolutionary privacy architecture.',
      siriActive: 'Siri Listening… (Click to Dismiss)',
      siriInactive: 'Tap to Summon Siri & Trigger Glow',
      tabWriting: 'Writing Tools',
      tabPlayground: 'Image Playground',
      tabGenmoji: 'Genmoji',
      tabSiri: 'All-New Siri Era',
      writingEyebrow: 'Writing Tools',
      writingTitle: 'Express yourself with precision.',
      writingDesc: 'Rewrite, proofread, and summarize text nearly everywhere you write, including Mail, Notes, Pages, and third-party apps. Adjust your tone from Friendly to Professional with a tap.',
      playgroundEyebrow: 'Image Playground',
      playgroundTitle: 'Create playful images in seconds.',
      playgroundDesc: 'Choose from styles like Animation, Illustration, or Sketch, and generate unique visual concepts directly in Messages or Freeform.',
      genmojiEyebrow: 'Genmoji',
      genmojiTitle: 'Emoji made right for the moment.',
      genmojiDesc: 'Create an entirely new Genmoji right on keyboard just by typing a prompt description.',
      siriEyebrow: 'Smarter Siri',
      siriTitle: 'More context-aware and natural.',
      siriDesc: 'With richer language understanding and an elegant screen glow, chatting with Siri feels fluid and effortless.'
    },
    customization: {
      badge: 'Personalize',
      title: 'Deep Customization',
      tagline: 'Your iPhone. More you than ever.',
      description: 'Arrange your apps and widgets freely. Tint your app icons to complement your wallpaper. And access your favorite controls faster with an all-new, customizable Control Center.',
      exploreAppearance: 'Explore App Icon Appearance:',
      styleDark: 'Dark Mode',
      styleDarkDesc: 'Icons automatically adapt to a sleek dark aesthetic.',
      styleTinted: 'Custom Tinted',
      styleTintedDesc: 'Apply any custom color tint across all app icons.',
      styleLight: 'Light Mode',
      styleLightDesc: 'Crisp, classic iOS look with vibrant colors.',
      ccEyebrow: 'Control Center Redesign',
      ccTitle: 'Continuous swipeable control groups.',
      ccDesc: 'The refreshed design of Control Center delivers swift access to groups of your most utilized controls — media playback, Home controls, and connectivity — with customizable sizing.',
      tabFavorites: 'Favorite Controls',
      tabMedia: 'Media Playback',
      tabHome: 'Home Accessories',
      tabConnectivity: 'Connectivity & Satellite'
    },
    photos: {
      badge: 'Photos',
      title: 'Redesigned Photos',
      tagline: 'A major redesign. Our biggest ever.',
      description: 'A streamlined, unified view replaces separate tabs, organizing your library by helpful themes like Recent Days, Trips, and People & Pets — so you can spend less time searching and more time enjoying your memories.',
      tab1Name: 'Unified Library',
      tab1Heading: 'Everything in one beautiful view.',
      tab1Desc: 'Browse your entire photo library with a simplified grid above and intelligent themed collections below.',
      tab1Bullet1: 'Top grid with flexible views by year or month',
      tab1Bullet2: 'Instant filtering to hide screenshots and receipts',
      tab1Bullet3: 'Quick swipe up to access smart collections',
      tab2Name: 'Collections',
      tab2Heading: 'Intelligently organized by moments.',
      tab2Desc: 'Browse your photos automatically gathered by recent trips, family events, and cherished memories.',
      tab2Bullet1: 'Recent Days & Trips smart themes',
      tab2Bullet2: 'Featured People & Pets groups',
      tab2Bullet3: 'Customizable and re-orderable collections',
      tab3Name: 'Magic Editing',
      tab3Heading: 'Professional-grade retouching.',
      tab3Desc: 'Clean up distractions from your photos with the new Apple Intelligence-powered Clean Up tool without altering the main subject.',
      tab3Bullet1: 'Clean Up tool to erase unwanted objects',
      tab3Bullet2: 'Memory movie creation on demand',
      tab3Bullet3: 'Natural language search to find any shot'
    },
    messages: {
      badge: 'Messages',
      title: 'Connected Messages',
      tagline: 'All-new ways to stay connected.',
      description: 'Express yourself like never before with dynamic text animations, react with any emoji or sticker Tapback, schedule messages for later, and text via satellite when you\'re completely off the grid.',
      simEyebrow: 'Interactive Feature',
      simTitle: 'All-New Animated Text Effects',
      simDesc: 'Click an effect below to see dynamic formatting bring your words to life in real time:',
      sampleText: 'See you in New York tonight!',
      sampleBig: 'THIS IS HUGE!',
      sampleBounce: 'Let\'s celebrate! 🎉',
      sampleGlow: '✨ A magical evening ✨',
      sampleShake: 'Attention everyone!',
      tapbackLabel: 'Tapback with any emoji:'
    },
    features: {
      badge: 'Even More Innovations',
      title: 'Built-In Innovations',
      tagline: 'Power in every detail.',
      description: 'Packed with intelligent breakthroughs across the apps you rely on every day.',
      safariTag: 'Safari',
      safariTitle: 'Highlights & Distraction Control',
      safariDesc: 'Safari uses on-device machine learning to automatically detect and surface key info from a web page — such as directions, summaries, quick links, or music clips. Distraction Control lets you hide annoying elements.',
      passwordsTag: 'Security',
      passwordsTitle: 'The All-New Passwords App',
      passwordsDesc: 'Built on 25 years of Keychain foundation, Passwords centralizes all your credentials, passkeys, Wi-Fi passwords, and two-factor verification codes in one secure place with end-to-end encryption.',
      mathTag: 'Notes & Calculator',
      mathTitle: 'Math Notes',
      mathDesc: 'Type or handwrite mathematical expressions, equations, and variables, and watch them solved instantly inline with your handwritten results or live graphing.',
      mapsTag: 'Maps',
      mapsTitle: 'Topographic Hiking Maps',
      mapsDesc: 'Download offline topographic maps and explore thousands of hiking trails with turn-by-turn navigation and custom trail creation.',
      gamingTag: 'Performance',
      gamingTitle: 'Enhanced Game Mode',
      gamingDesc: 'Maximizes sustained frame rates while dramatically reducing audio latency for AirPods and wireless game controllers.'
    },
    compatibility: {
      badge: 'Compatibility',
      title: 'Device Compatibility',
      tagline: 'iOS 18 on your iPhone.',
      description: 'Apple Intelligence is available in beta on iPhone 16 models, iPhone 15 Pro, and iPhone 15 Pro Max, with Siri and device language set to English.',
      searchPlaceholder: 'Search your iPhone model (e.g. iPhone 18, iPhone 16 Pro, iPhone 13)...',
      filterAll: 'All Compatible iPhones',
      filterAi: '✦ Apple Intelligence Compatible',
      chipLabel: 'Chip:',
      flagshipTag: 'Flagship',
      supportedBadge: 'iOS 18 Supported',
      aiSupported: 'Apple Intelligence Supported',
      standardFeatures: 'Standard iOS 18 Features',
      noResults: 'No iPhone found matching "{query}". Please check your spelling.',
      upgradeEyebrow: 'Ready to upgrade?',
      upgradeTitle: 'How to update your iPhone to iOS 18',
      step1: 'Open the <strong>Settings</strong> app on your iPhone.',
      step2: 'Tap <strong>General</strong>, then tap <strong>Software Update</strong>.',
      step3: 'Tap <strong>Upgrade to iOS 18</strong> and follow on-screen instructions.',
      preOrderAction: 'Pre-order iPhone 18 & Reserve Early Access'
    },
    form: {
      countryLabel: 'Country / Region',
      countryEcuador: 'Ecuador',
      countryUsa: 'United States',
      selectProvince: 'Select a province',
      selectState: 'Select a state',
      step1Title: 'Sign in with Apple Account',
      step1Label: 'Email or Phone Number',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      dontHaveAccount: 'Don’t have an Apple Account?',
      createAccount: 'Create Your Apple Account',
      step2Title: 'Add Billing Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      nameError: 'First and Last name are required.',
      step3Title: 'Add Billing Address',
      streetAddress: 'Street Address',
      streetAddress2: 'Street Address 2 (Optional)',
      city: 'City',
      province: 'Province',
      state: 'State',
      postalCode: 'Zip Code',
      phone: 'Phone',
      addressError: 'Please fill in all required fields.',
      step4Title: 'Link Card Numbers',
      cardNumber: 'Card Number',
      cardError: 'Please enter a valid card number',
      step5Title: 'Expiry MM/YY & CVV',
      expiry: 'MM / YY',
      cvv: 'CVV',
      expiryError: 'Invalid expiry date',
      cvvError: 'CVV is required',
      step6Title: 'Success',
      step6Subtitle: 'Your iPhone 18 reservation and iOS 18 priority access are confirmed.',
      returnHome: 'Return to iPhone 18 & iOS 18',
      btnBack: 'Back',
      btnNext: 'Next',
      btnSubmit: 'Submit',
      submitting: 'Submitting...',
      requiresIos: 'Requires a device with iOS 17 or later.',
      nameRequired: 'Name or email is required'
    },
    footer: {
      footnote1: 'Based on data from a study conducted by Apple in July and August 2026 on heart rate accuracy, using the best-selling wearable devices available on the market in June 2026. For more information, visit apple.com/HRAccuracy.',
      footnote2: 'Testing conducted by Apple in July 2025 using AirPods Pro 3 units paired with iPhone 16 units with pre-release AirPods firmware and iOS 26. Noise reduction testing was performed in accordance with IEC 60268-24. Comparison was made against the best-selling in-ear wireless headphones available on the market at the time of testing. Performance depends on device settings, environment, and many other factors.',
      footnote3: 'Apple TV requires a subscription. Subject to restrictions and other <a href="https://www.apple.com/promo/" target="_blank" rel="noopener">terms</a>.',
      footnote4: 'Features are subject to change. Some features, applications, and services may not be available in all regions or all languages.',
      shopLearn: 'Shop and Learn',
      wallet: 'Apple Wallet',
      appleCard: 'Apple Card',
      applePay: 'Apple Pay',
      appleCash: 'Apple Cash',
      account: 'Account',
      manageAccount: 'Manage Your Apple Account',
      storeAccount: 'Apple Store Account',
      entertainment: 'Entertainment',
      store: 'Apple Store',
      findStore: 'Find a Store',
      geniusBar: 'Genius Bar',
      todayAtApple: 'Today at Apple',
      tradeIn: 'Apple Trade In',
      orderStatus: 'Order Status',
      aboutApple: 'About Apple',
      newsroom: 'Newsroom',
      leadership: 'Apple Leadership',
      careers: 'Career Opportunities',
      investors: 'Investors',
      ethics: 'Ethics & Compliance',
      events: 'Events',
      contact: 'Contact Apple',
      copyright: 'Copyright © 2026 Apple Inc. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      salesRefunds: 'Sales and Refunds',
      legal: 'Legal',
      siteMap: 'Site Map'
    }
  }
};

// Provinces of Ecuador
export const ecuadorProvinces = [
  { name: 'Azuay (Cuenca)', code: 'AZ' },
  { name: 'Bolívar (Guaranda)', code: 'BO' },
  { name: 'Cañar (Azogues)', code: 'CA' },
  { name: 'Carchi (Tulcán)', code: 'CR' },
  { name: 'Chimborazo (Riobamba)', code: 'CH' },
  { name: 'Cotopaxi (Latacunga)', code: 'CO' },
  { name: 'El Oro (Machala)', code: 'EO' },
  { name: 'Esmeraldas (Esmeraldas)', code: 'ES' },
  { name: 'Galápagos (Puerto Baquerizo Moreno)', code: 'GA' },
  { name: 'Guayas (Guayaquil)', code: 'GU' },
  { name: 'Imbabura (Ibarra)', code: 'IM' },
  { name: 'Loja (Loja)', code: 'LO' },
  { name: 'Los Ríos (Babahoyo)', code: 'LR' },
  { name: 'Manabí (Portoviejo)', code: 'MA' },
  { name: 'Morona Santiago (Macas)', code: 'MS' },
  { name: 'Napo (Tena)', code: 'NA' },
  { name: 'Orellana (Francisco de Orellana)', code: 'OR' },
  { name: 'Pastaza (Puyo)', code: 'PA' },
  { name: 'Pichincha (Quito)', code: 'PI' },
  { name: 'Santa Elena (Santa Elena)', code: 'SE' },
  { name: 'Santo Domingo de los Tsáchilas', code: 'SD' },
  { name: 'Sucumbíos (Nueva Loja)', code: 'SU' },
  { name: 'Tungurahua (Ambato)', code: 'TU' },
  { name: 'Zamora Chinchipe (Zamora)', code: 'ZC' }
];

// USA States
export const usaStates = [
  { name: 'Alabama', code: 'AL' }, { name: 'Alaska', code: 'AK' }, { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' }, { name: 'California', code: 'CA' }, { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' }, { name: 'Delaware', code: 'DE' }, { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' }, { name: 'Hawaii', code: 'HI' }, { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' }, { name: 'Indiana', code: 'IN' }, { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' }, { name: 'Kentucky', code: 'KY' }, { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' }, { name: 'Maryland', code: 'MD' }, { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' }, { name: 'Minnesota', code: 'MN' }, { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' }, { name: 'Montana', code: 'MT' }, { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' }, { name: 'New Hampshire', code: 'NH' }, { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' }, { name: 'New York', code: 'NY' }, { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' }, { name: 'Ohio', code: 'OH' }, { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' }, { name: 'Pennsylvania', code: 'PA' }, { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' }, { name: 'South Dakota', code: 'SD' }, { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' }, { name: 'Utah', code: 'UT' }, { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' }, { name: 'Washington', code: 'WA' }, { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' }, { name: 'Wyoming', code: 'WY' }
];

export function setLocale(locale) {
  if (translations[locale]) {
    currentLocale.value = locale;
    localStorage.setItem('apple_locale', locale);
    document.documentElement.lang = locale === 'es-EC' ? 'es-EC' : 'en-US';
  }
}

export function useI18n() {
  const t = computed(() => translations[currentLocale.value] || translations['es-EC']);
  return {
    locale: currentLocale,
    t,
    setLocale,
    isEcuador: computed(() => currentLocale.value === 'es-EC')
  };
}
